import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as DeleteIcon } from '@assets/svg/manage-equipment/ic-delete.svg';
import { ReactComponent as EditIcon } from '@assets/svg/manage-equipment/ic-edit.svg';

import { MODAL_NAMES } from '@constants/modalRenderers';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import type { IFacilityGroup } from '@model/facilityGroup';

import { useModalActions } from '@store/useModalStore';

import { useFacilityGroupDeleteMutation } from '../../services/useFacilityGroupDeleteMutation';
import style from './style.module.scss';

interface IProps {
  id: string;
}

const ContextMenu: React.FC<IProps> = ({ id }) => {
  const { t } = useTranslation();

  const { setActiveModal, setModalClose } = useModalActions();

  const { mutate: facilityGroupDeleteMutate } = useFacilityGroupDeleteMutation();

  const handleOpenEditGroupModal = (rowGroup: IFacilityGroup) => {
    setActiveModal({ name: MODAL_NAMES.createEditFacilityGroupModal, options: { facilityGroup: rowGroup } });
  };

  const handleOpenConfirmDeleteModal = (rowGroup: IFacilityGroup) => {
    setActiveModal({
      name: MODAL_NAMES.modalConfirm,
      options: {
        bodyTitle: `${t('Delete Facility Group')} “${rowGroup.name}”`,
        bodyContent: `${t('Are you sure you want to delete this facility group')} “${rowGroup.name}”`,
        confirmText: t('Delete'),
        onConfirm: () => {
          facilityGroupDeleteMutate(
            {
              group_id: rowGroup.id,
            },
            {
              onSuccess: () => {
                showToast({ variant: 'success', message: t('Facility group successfully deleted.') });
                setModalClose();
              },
            },
          );
        },
        onCancel: () => setModalClose(),
      },
    });
  };

  return (
    <Tooltip
      id={id}
      place="left"
      openOnClick
      className={style.contextMenuPopover}
      clickable
      disableStyleInjection
      render={({ content }) => {
        if (!content) {
          return null;
        }
        const rowGroup: IFacilityGroup = JSON.parse(content);

        return (
          <>
            <div className={style.contextMenuPopoverItem} onClick={() => handleOpenEditGroupModal(rowGroup)}>
              <EditIcon className={style.menuIcon} />
              {t('Edit')}
            </div>
            <div
              className={style.contextMenuPopoverItem}
              onClick={() => handleOpenConfirmDeleteModal(rowGroup)}
            >
              <DeleteIcon className={style.menuIcon} />
              {t('Delete')}
            </div>
          </>
        );
      }}
    />
  );
};

export default ContextMenu;
